module.exports = __webpack_public_path__ + "static/media/Clefable_gaussian2.8a802e3f.png";